import { create } from "zustand";

import axios from "../helper/axios";

const useMembersStore = create((set) => ({
    teamMembers: [],
    vendors: [],
    clients:[],
    clientsFlag:false,
    assignedTeamMembers: [],
    assignedVendorConnects: [],
    assignedTeamMembersFlag:false,
    teamMembersFlag:false,
    assignedVendorsFlag:false,
    assignedTeamMembersRefreshFlag:false,
    currSubscription:null, //start with it till the servers gets the real subscription
    timeSheetApprovarList: [],
    leaveApprovarList: [],
    updateTeamFlag: false,

    getTeamMembers: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/users/${userData.qhoid}/role/TeamMember`
            );
            //console.log("getTeamMembers", response.data)
            set({ teamMembers: response.data.data });
            set({ timeSheetApprovarList: response.data.alist });
            set({ leaveApprovarList: response.data.llist });

        } catch (err) {
            console.error(err);
        }
    },
    getVendors: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/users/${userData.qhoid}/role/VendorConnect`
            );

            set({ vendors: response.data });
        } catch (err) {
            console.error(err);
        }
    },
    getClients: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getclients/${userData.qhoid}`
            );
            if(response.data != null) set({ clients: response.data });
            set({ clientsFlag: true });            
            //console.log(response.data);
        } catch (err) {
            console.error(err);
        }
    },    
    getAssignedMembers: async (jdId) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            set({ assignedTeamMembersFlag: true });
            const response = await axios.get(
                `getassigned/${userData.qhoid}/${userData.qhuid}/${jdId}/TeamMember`
            );
            set({ assignedTeamMembers: response.data });
            set({ assignedTeamMembersRefreshFlag: true });
            set({ assignedTeamMembersFlag: false });
                
            //console.log("getassigned",response.data);
        } catch (err) {
            console.error(err);
            set({ assignedTeamMembersFlag: false });
        }
    },
    checkSubscriptions: async (cb) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/checkSubscription/${userData.qhoid}/${userData.qhuid}`
            );
            set({ currSubscription: response.data.data });
            
            if(cb) cb(response.data.data);
            // console.log(response.data);
        } catch (err) {
            console.error(err);
        }
    }, 
    setSubscription: async () =>{
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            if(userData.subscriptionstatus == "subscription_none"){
                set({ currSubscription: userData.trialstatus });
            }else{
                set({ currSubscription: userData.subscriptionstatus });
            }
            
        } catch (err) {
            console.error(err);
        }
    },  
    updateUserDetails: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/updateUserDetails/${userData.qhoid}/${userData.qhuid}`,
                body.jasonValues
            );
            //console.log(response.data.name); 
            //console.log(response.data.status);
            set({ updateTeamFlag: true });
        } catch (err) {
            console.error(err);
        }
    }, 
    updateUserDoc: async (owner_id,user_id, docData) => {
        console.log(user_id, docData);

        try {
            const formData = new FormData();
            Object.keys(docData).forEach(key => {
                formData.append(key, docData[key]);
            });

            const response = await axios.put(`/updateUserDoc/${owner_id}/${user_id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log(response.data);

            return response.data;
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, 

    resetAssignedTeamMemberRefreshFlag: () => {
        set({ assignedTeamMembersRefreshFlag: false });
    },
    resetClientsFlag: () => {
        set({ clientsFlag: false });
    },    
    resetUpdateFlag: () => {
        set({ updateTeamFlag: false });
    },    
  updateUserInfo: async (qhoid, formData) => {
    try {
      const response = await axios.put(`/updateUserInfo/${qhoid}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const currentUser = JSON.parse(localStorage.getItem("userDetails")) || {};
      const updatedUser = { ...currentUser };

      if (formData instanceof FormData) {
        for (const [key, value] of formData.entries()) {
          if (value instanceof File || value instanceof Blob) {
            const fileAsDataUrl = await new Promise((resolve, reject) => {
              const fileReader = new FileReader();
              fileReader.onload = () => resolve(fileReader.result);
              fileReader.onerror = () => reject(new Error("Failed to read uploaded file"));
              fileReader.readAsDataURL(value);
            });

            if (key === "companyLogo") {
              updatedUser.company_logo = fileAsDataUrl;
            } else if (key === "profileImage") {
              updatedUser.company_logo = fileAsDataUrl;
            } else {
              updatedUser[key] = fileAsDataUrl;
            }
            continue;
          }

          if (typeof value === "string") {
            try {
              const parsedValue = JSON.parse(value);
              updatedUser[key] = parsedValue;
            } catch {
              updatedUser[key] = value;
            }
          } else {
            updatedUser[key] = value;
          }
        }
      }

      localStorage.setItem("userDetails", JSON.stringify(updatedUser));
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
}));

export default useMembersStore;
